// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"wizardFooter_buttonGroup__1q83u","primaryButton":"wizardFooter_primaryButton__2XtHp"};